// Lista de Lead Magnets de la org — métrica norte: subscriber_count.
// Click en una row → setSelected → tabla de subscribers + sequence builder.

import { useLeadMagnets } from '../hooks/useLeadMagnets';
import type { LeadMagnet } from '../types';

const TYPE_LABEL: Record<string, string> = {
  pdf: 'PDF',
  quiz: 'Quiz',
  checklist: 'Checklist',
  'email-course': 'Email course',
};

interface Props {
  onSelect?: (magnet: LeadMagnet) => void;
  selectedId?: number | null;
}

export function LeadMagnetList({ onSelect, selectedId }: Props) {
  const { data, loading, error, refetch } = useLeadMagnets({ limit: 100 });

  if (loading && !data) {
    return <div className="p-6 text-sm text-muted-foreground">Cargando lead magnets…</div>;
  }
  if (error) {
    return (
      <div className="p-6 text-sm text-destructive">
        Error: {error} · <button onClick={refetch} className="underline">Reintentar</button>
      </div>
    );
  }
  if (!data || data.items.length === 0) {
    return (
      <div className="p-6 text-sm text-muted-foreground">
        Aún no hay lead magnets. Crea el primero — ej. una checklist para
        personal-brand (org sugerida: <code>samuelplata</code>).
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-left border-b">
            <th className="px-3 py-2">#</th>
            <th className="px-3 py-2">Slug</th>
            <th className="px-3 py-2">Título</th>
            <th className="px-3 py-2">Tipo</th>
            <th className="px-3 py-2">Subs</th>
            <th className="px-3 py-2">Estado</th>
            <th className="px-3 py-2">Landing</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((m) => {
            const isSel = selectedId === m.id;
            return (
              <tr
                key={m.id}
                className={
                  'border-b cursor-pointer hover:bg-muted ' +
                  (isSel ? 'bg-primary/10' : '')
                }
                onClick={() => onSelect?.(m)}
              >
                <td className="px-3 py-2 font-mono text-xs">{m.id}</td>
                <td className="px-3 py-2 font-mono text-xs">{m.slug}</td>
                <td className="px-3 py-2 font-medium">{m.title}</td>
                <td className="px-3 py-2">{TYPE_LABEL[m.type] || m.type}</td>
                <td className="px-3 py-2 text-right">{m.subscriber_count}</td>
                <td className="px-3 py-2">
                  {m.active ? (
                    <span className="text-primary">activo</span>
                  ) : (
                    <span className="text-muted-foreground">inactivo</span>
                  )}
                </td>
                <td className="px-3 py-2 text-xs">
                  <a
                    href={m.public_url}
                    target="_blank"
                    rel="noreferrer"
                    className="underline text-primary"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {m.public_url}
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="px-3 py-2 text-xs text-muted-foreground">
        Total: {data.count}
      </div>
    </div>
  );
}
